import { Injectable } from '@angular/core';
import { HelperService } from '@pwaPortal/core/services/helper/helper.service';
import { LoggerEventsEnum } from '../../enums/logger-events.enum';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor(private helperService: HelperService) {}

  public async sendPxEvent() {
    console.log('[sending pixel]');
    const params = await this.helperService.getParams();
    const data = {
      type: 'fb',
      pixId: params.pixel,
      fbClId: params.fbclid,
      fbP: params._fbp,
      fbC: params._fbc,
    };
    const clientId = this.helperService.getUserId();
    const trackingUrl = '/tracking/data/' + clientId;
    const headers = {
      'content-type': 'application/json',
    };
    const resp = await fetch(trackingUrl, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: headers,
    });
  }

  public async sendFetchEvent(event: LoggerEventsEnum) {
    let url = '/tracking/event?type={event_type}&visitor={visit_id}';
    const visitId = this.helperService.getUserId();
    url = url.replace('{event_type}', event);
    url = url.replace('{visit_id}', visitId);
    // alert('sending event ' + url);
    const resp = await fetch(url, {
      method: 'GET',
    });
  }
}
